module.exports = __webpack_public_path__ + "static/farnoosh-1870358910c0feced39be19756c6c8cd.png";